import React from 'react';
import { makeStyles } from '@material-ui/core';
import { CloudOff } from '@material-ui/icons';

import StatusMessage from 'components/StatusMessage';

const useStyles = makeStyles((theme) => {
  return {
    /* Styles applied to the root element. */
    root: {},
    bodyText: {
      whiteSpace: 'pre-line',
    },
    statusMessage: {
      padding: theme.spacing(2, 3),

      lineHeight: theme.typography.pxToRem(24),
      letterSpacing: theme.typography.pxToRem(0.15) + '!important',
    },
  };
});

const CollaborationOfflineMessage = ({ ...props }) => {
  const classes = useStyles();

  return (
    <StatusMessage
      className={classes.statusMessage}
      icon={<CloudOff />}
      title={'You’re Offline'}
      {...props}
    >
      <span className={classes.bodyText}>
        {`Your network connection is unavailable.\nWhile offline, you will not be able to share your notes of view other people’s notes.`}
      </span>
    </StatusMessage>
  );
};

export default CollaborationOfflineMessage;
